// extracted by mini-css-extract-plugin
module.exports = {"c18irxm6":"c18irxm6","b7k1b71":"b7k1b71","perspectiveSpin-b7k1b71":"perspectiveSpin-b7k1b71"};